<template>
	<b-col cols="12" xl="4" class="mb-5 mb-xl-0" :style="packStyle">
		<div class="h-100 d-flex flex-column justify-content-between align-items-center shadow rounded bg-white p-5">
			<div class="d-flex flex-column align-items-center">
				<img :src="pack.image.src" :alt="pack.image.alt" width="50" height="auto" class="mb-2" />

				<h2 class="h4 text-primary mb-5">{{ pack.text }}</h2>
			</div>

			<div class="h-100 w-100 border-bottom mb-5">
				<ul class="p-0">
					<li v-if="pack.packIncluded" class="d-flex align-items-start text-primary font-weight-bold">
						<img src="@/assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="auto" class="mr-2">
						{{ pack.packIncluded }} +
					</li>
					<li v-for="(advantage, index) in pack.advantages" :key="index" class="d-flex align-items-start">
						<img src="@/assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="auto" class="mr-2">
						{{ advantage }}
					</li>
				</ul>
				
				<div v-if="index === 0" class="mt-4">
					<p class="font-weight-bold">Auto-entrepreneur / Micro-entreprise</p>
					<ul class="p-0">
						<li v-for="(selfEmployedAdvantage, index) in pack.selfEmployedAdvantages" :key="index" class="d-flex align-items-start">
							<img src="@/assets/images/icons/tick/tick.svg" alt="Flèche rouge vers la droite" width="20" height="auto" class="mr-2">
							{{ selfEmployedAdvantage }}
						</li>
					</ul>
				</div>
				
				<b class="text-danger mb-5 text-left d-block" v-if="pack.announcement">{{ pack.announcement }}</b>
			</div>

			<b class="h4 font-weight-bold">{{ pack.price }}{{ services.currency }} {{ services.tva }}</b>
		</div>
	</b-col>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		props: {
			index: {
				type: Number,
				required: true
			},
			pack: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				packStyle: {
					zIndex: 0,
					marginRight: 0,
					marginLeft: 0,
					height: ""
				}
			}
		},
		computed: {
			...mapState(['services'])
		},
		/* mounted() {
			if (window.outerWidth > 1200) {
				if (this.index === 1) {
					this.packStyle = {
						zIndex: 10,
						marginRight: "-50px",
						marginLeft: "-50px",
						height: "800px"
					}
				} else {
					this.packStyle = {
						zIndex: 0,
						marginRight: "0",
						marginLeft: "0",
						height: "700px"
					}
				}
			}
		} */
	}
</script>